import { NOMBRE_SEGMENTS } from '@mosaik/core';
import type { CommandeCalculee } from '../api/types';

/**
 * Barre de progression en 5 segments.
 *
 * Elle dit **où en est** la commande, pas ce qu'elle réclame. La gravité y
 * était portée en couleur — vert, jaune, rouge — ce qui faisait dire deux
 * choses au même repère et teintait la liste entière ; la colonne « Action »
 * dit déjà l'urgence, en toutes lettres.
 */
export function Progression({ calcul, compact = false }: { calcul: CommandeCalculee; compact?: boolean }) {
  const etiquette = `${calcul.libelleEtape} — ${calcul.detailEtape}`;
  return (
    <>
      <div className="step" role="img" aria-label={etiquette}>
        {Array.from({ length: NOMBRE_SEGMENTS }, (_, k) => (
          <i
            key={k}
            className={[k < calcul.segment ? 'on' : '', k === calcul.segment ? 'cur' : '']
              .filter(Boolean).join(' ')}
          />
        ))}
      </div>
      <div className="steplab">
        <span>{calcul.libelleEtape}</span>
        {!compact && <em>{calcul.detailEtape}</em>}
      </div>
    </>
  );
}
